import { makeAutoObservable } from "mobx";
import type { RawContractorData, RawLegalData } from "../legal-types";

// ─── Статус-стор: существует ли юр. данные + сырые данные из API ─────────────

export class LegalStatusStore {
  hasLegalData = false;
  isLegalDataFilled = false;
  legalType: "legal" | "selfemployed" | null = null;
  isLoadingCheck = false;
  rawLegalData: RawLegalData | null = null;
  rawContractorData: RawContractorData | null = null;
  tbankRegisteredAt: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  get isTBankRegistered(): boolean {
    return !!this.tbankRegisteredAt;
  }

  reset = () => {
    this.hasLegalData = false;
    this.isLegalDataFilled = false;
    this.legalType = null;
    this.isLoadingCheck = false;
    this.rawLegalData = null;
    this.rawContractorData = null;
    this.tbankRegisteredAt = null;
  };
}
